import RestService from "./rest.service";

class importFilesService {
  getTemplateType() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/migration`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  uploadFiles(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/migration/import`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  startProcess(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/migration/process`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getList(limit, page, result, sort_by, sort) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/migration/history?limit=${limit}&page=${page}${result !== "" ? `&result=${result}` : ""}${sort_by !== "" ? `&sort_by=${sort_by}` : ""}${sort !== "" ? `&sort=${sort}` : ""}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getDetail(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/migration/history/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  downloadTemplate(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/migration/template/download`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  export(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/migration/history/${serial}/export`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new importFilesService();
